import { createContext, useContext, useEffect, useState } from "react";
import { adminApi } from "../lib/api";

const AdminAuthContext = createContext(null);

export const AdminAuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("amyu_admin_token");
    if (!token) {
      setChecking(false);
      return;
    }
    adminApi
      .get("/admin/me")
      .then((r) => setAdmin(r.data))
      .catch(() => {
        localStorage.removeItem("amyu_admin_token");
        setAdmin(null);
      })
      .finally(() => setChecking(false));
  }, []);

  const login = async (email, password) => {
    const r = await adminApi.post("/admin/login", { email, password });
    localStorage.setItem("amyu_admin_token", r.data.token);
    const me = await adminApi.get("/admin/me");
    setAdmin(me.data);
    return me.data;
  };

  const logout = () => {
    localStorage.removeItem("amyu_admin_token");
    setAdmin(null);
    window.location.href = "/admin/login";
  };

  return (
    <AdminAuthContext.Provider value={{ admin, checking, login, logout }}>
      {children}
    </AdminAuthContext.Provider>
  );
};

export const useAdminAuth = () => useContext(AdminAuthContext);
